const modifiedFields = [
  'widgetName',
  'projectModel',
  'resourceTypeModel',
  'productModel',
  'selectedMetrics',
  'objectModel'
];
const modifiedFieldCustom = {};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
